import React from 'react';
import { Alert, Container, Form, Row, Col } from 'react-bootstrap';
import SizeFormBig from '../../questionnaire/SizeFormBig';
// import WbIridescentOutlinedIcon from '@mui/icons-material/WbIridescentOutlined';
import RadioButtonForm from '../../questionnaire/RadioButtonForm';
import { CloseBtnForFilter } from '../../assets/CloseBtnForFilter';
import Server from '../../server/server';
import { ButtonGroupForFilterForms } from '../../assets/ButtonGroupForFilterForms';


export default class FormRolling extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            language: 'rus',
            show: true,
            nameForm: 'FormRolling',
            maxId: 15,
            dataValue: [],
            dataOnServer: [],
            dataFromServer: [],
            lengthDataFromServer: 0,
            showVariants: true
        }

        this.doChangeValue = this.doChangeValue.bind(this);
        this.handleClickSave = this.handleClickSave.bind(this);
        this.handleClickShadow = this.handleClickShadow.bind(this);
        this.doEmpty = this.doEmpty.bind(this);
        this.doQuitWithSave = this.doQuitWithSave.bind(this);
        this.doQuitWithoutSave = this.doQuitWithoutSave.bind(this);
        // this.doChangeVisionBlock = this.doChangeVisionBlock.bind(this);
        this.handleClickMaterieals = this.handleClickMaterieals.bind(this);
        this.clearFields = this.clearFields.bind(this);
        this.onKeyPressHandler = this.onKeyPressHandler.bind(this);
        this.sendProductDataOnServer = this.sendProductDataOnServer.bind(this)
    }

    async clearFields() {
        await this.setState({
            showVariants: false
        })

        this.setState({
            showVariants: true
        })
    }


    handleClickMaterieals() {
        this.props.onRunMaterials('Four_FormRolling');
    }

    //* empty
    doEmpty() {
    }


    //запуск выхода из формы
    handleClickShadow() {
        this.setState({ showQuit: true })
    }

    //выход с сохранением
    doQuitWithSave() {
        this.setState({ showQuit: false })
        this.handleClickSave();
        this.props.onChangeView(this.state.nameForm);

    }
    //выход без сохранения
    doQuitWithoutSave() {
        this.setState({ showQuit: false })
        this.props.onChangeView(this.state.nameForm);

    }

    //*формируем данные в массив объектов для отправки на сервер
    async handleClickSave(e) {
        e.preventDefault()
        let data = this.state.dataOnServer;

        for (let i = 0; i <= (this.state.maxId); i++) {

            //todo создаем позицию с пустым объектом
            data[i] = { id: '', fid: '', description: '', information: '', value: '' }

            //todo заполняем объект данными с сервера
            this.state.dataFromServer.forEach((dataD) => {
                if (+dataD.id === i) {
                    data[i] = { id: dataD.id, fid: dataD.fid, description: dataD.description, information: dataD.information, value: dataD.value }
                }
            })
            //todo заполняем объект данными с формы
            this.state.dataValue.forEach((dataE) => {
                if (+dataE.id === i) {
                    data[i] = { id: dataE.id, fid: dataE.fid, description: dataE.description, information: dataE.information, value: dataE.value }
                }
            })

        }
        await this.setState({ dataOnServer: data }) //todo проверка на наличие данных на сервере

        this.props.getChosenFiltersData(data)
        //отправляем родителю имя этой формы
        // this.props.getFormName(this.state.nameForm)
        //берем данные с сервера
        this.props.saveChosenFilters()

        
        const result = await Server.filterProductionCompany(data, this.state.nameForm)
        await this.props.sendSearchResultData(result)
        this.props.openResultTable()
        this.props.closeModal(e)
    }

    //* данные с полей формы, формируются в массив объектов
    async doChangeValue(data) {
        await this.setState({ dataValue: [...this.state.dataValue, data] })
    }

    onKeyPressHandler(event) {
        event.target.dataset.position = 25
        if (event.keyCode === 13) {
            this.handleClickSave(event)
        }
    }

    async sendProductDataOnServer() {
        const productData = {
            product: this.props.product,
            formName: this.state.nameForm
        }
        await Server.sendDataOnServer(productData, 'product', localStorage.getItem('idUser'))
    }

    async componentDidMount() {
        await this.setState({ dataFromServer: this.props.data, lengthDataFromServer: this.props.lengthDataFromServer });

        document.addEventListener('keydown', this.onKeyPressHandler)

        await this.sendProductDataOnServer()
    }

    componentWillUnmount() {
        document.removeEventListener('keydown', this.onKeyPressHandler)
    }


    render() {

        const view = this.props.view;
        this.value = this.props.data;
        const viewQuest = this.props.viewQuest;
        const VALZOVKA = [
            'Толщина листа, мм',
            'Диаметр обечайки, мм',
            'Ширина заготовки, мм',
        ]

        return (
            <>

                <div className="modal_window" style={{ display: view ? 'block' : 'none' }} >
                    <div className={viewQuest ? "shadow_form" : "shadow_form_off"} onClick={this.props.closeModal}  ></div>
                    <Form className={this.props.chosenCompaniesFromProductionSearch && this.props.chosenCompaniesFromProductionSearch.length >= 0 ? "form_main" : "form_main_1"}  >
                        <Alert
                            variant="dark"
                            className="filter_alert"
                        >
                            <Alert.Heading >Услуги по аттестации технологий вальцовки</Alert.Heading>
                            <CloseBtnForFilter dataId={25} closeModal={this.props.closeModal} />
                        </Alert>
                        <div>
                            <Container className="form_container">
                            <Form.Group>
                                <Row>
                                    <Col>
                                        Размеры углеродистой стали:
                                    </Col>
                                </Row>
                                <Form.Group>
                                    <Row>
                                        <Col>
                                            {this.state.showVariants && <SizeFormBig
                                                id={1}
                                                width={2}
                                                show={this.state.show}
                                                verify="number"
                                                // label="Толщина, мм"
                                                fontSize={'12px'}
                                                placeholder={VALZOVKA}
                                                description="Вальцовка"
                                                value={this.value}
                                                onChangeValue={this.doChangeValue}
                                                nameForm={this.state.nameForm}
                                            />}
                                        </Col>
                                    </Row>
                                </Form.Group>

                                <Form.Group>
                                    <Row>
                                        <Col>
                                            Размеры нержавеющей стали:
                                        </Col>

                                    </Row>

                                    <Row>

                                        <Col>
                                            {this.state.showVariants && <SizeFormBig
                                                id={6}
                                                width={2}
                                                show={this.state.show}
                                                verify="number"
                                                // label="Толщина, мм"
                                                fontSize={'12px'}
                                                placeholder={VALZOVKA}
                                                description="Вальцовка"
                                                value={this.value}
                                                onChangeValue={this.doChangeValue}
                                                nameForm={this.state.nameForm}
                                            />}
                                        </Col>
                                    </Row>
                                </Form.Group >
                                {this.state.showVariants && <><Row>
                                    <RadioButtonForm
                                        id={11}
                                        width={12}
                                        show={true}
                                        title="Возможность изготовления конусных обечеек: "
                                        label1="Да"
                                        label2="Нет"
                                        placeholder="Имеется ли возможность изготовления конусных обечеек?"
                                        description="Вальцовка"
                                        value={this.value[11] ? this.value[11].value : ''}
                                        onChangeValue={this.doChangeValue}
                                        onChangeVisionBlock={this.doEmpty}
                                        nameForm={this.state.nameForm}
                                    />
                                </Row >

                                    <Form.Group>
                                        <Row>
                                            <RadioButtonForm
                                                id={12}
                                                width={12}
                                                show={true}
                                                title="Возмжность термической обработки после вальцовки и сварки: "
                                                label1="Да"
                                                label2="Нет"
                                                placeholder="Термическая обработка после вальцовки и сварки?"
                                                description="Вальцовка"
                                                value={this.value[12] ? this.value[12].value : ''}
                                                onChangeValue={this.doChangeValue}
                                                onChangeVisionBlock={this.doEmpty}
                                                nameForm={this.state.nameForm}
                                            />
                                        </Row>
                                    </Form.Group>

                                    <Form.Group>
                                        <Row>
                                            <RadioButtonForm
                                                id={13}
                                                width={12}
                                                show={true}
                                                title="Возможность механических испытаний материалов сварного шва после термической обработки: "
                                                label1="Да"
                                                label2="Нет"
                                                placeholder="Механические испытания материалов сварного шва после термической обработки?"
                                                description="Вальцовка"
                                                value={this.value[13] ? this.value[13].value : ''}
                                                onChangeValue={this.doChangeValue}
                                                onChangeVisionBlock={this.doEmpty}
                                                nameForm={this.state.nameForm}
                                            />

                                        </Row>
                                    </Form.Group></>}

                                <Row> &nbsp;</Row>
                            </Form.Group>
                            <Row>&nbsp;</Row>
                        </Container >
                            <ButtonGroupForFilterForms
                                dataId={25}
                                handleClickSave={this.handleClickSave}
                                clearFields={this.clearFields}
                                savedFiltersData={this.props.savedFiltersData}
                            />
                        </div>
                        
                    </Form >
                </div >
            </>
        )
    }
}